import React from 'react'

import Typography from '@material-ui/core/Typography'
import Paper from '@material-ui/core/Paper'
import Button from '@material-ui/core/Button'

import useStyles from './style'

export default function FormPaginate({
  children,
  title,
  handleSubmit,
  titleButton,
  disable,
  handleNewPage,
  page,
  lastPage,
}) {
  const classes = useStyles()

  return (
    <main className={classes.layout}>
      <Paper className={classes.paper}>
        <div className={classes.header}>
          <Typography className={classes.title} component="h3" variant="h5">
            {title}
          </Typography>
        </div>
        <div className={classes.form}>
          {children}
          <div className={classes.buttons}>
            <Button
              variant="contained"
              color="primary"
              onClick={(e) => handleSubmit(e)}
              disabled={disable}
              className={classes.button}
            >
              {titleButton}
            </Button>
            {page > 1 && (
              <a onClick={() => handleNewPage(page - 1)}>
                <img
                  className={classes.arrow}
                  src={'../../assets/images/arrow_back_question.png'}
                />
              </a>
            )}
            {page < lastPage && (
              <a onClick={() => handleNewPage(page + 1)}>
                <img
                  className={classes.arrow}
                  src={'../../assets/images/arrow_next_question.png'}
                />
              </a>
            )}
          </div>
        </div>
      </Paper>
    </main>
  )
}
